import { User } from '../models';

export function canViewAllSmats(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('smatPlans.') || m.startsWith('smats.'));
}

export function canViewAllRisks(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('risks.'));
}

export function hasSmatPlansPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('smatPlans.'));
}

export function hasReportsPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m === 'reports.view');
}

export function hasAdminPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  return (
    hasAdminUsersPageRole(user) ||
    hasAdminRolesPageRole(user) ||
    hasAdminAreasPageRole(user) ||
    hasAdminRiskPrioritiesPageRole(user) ||
    hasAdminRiskCategoriesPageRole(user) ||
    hasAdminSystemSettingsPageRole(user)
  );
}

export function hasAdminUsersPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('users.'));
}

export function hasAdminRolesPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('roles.'));
}

export function hasAdminLocationsPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('locations.'));
}

export function hasAdminAreasPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('areas.'));
}

export function hasAdminRiskPrioritiesPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('riskPriorities.'));
}

export function hasAdminRiskCategoriesPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('riskCategories.'));
}

export function hasAdminSystemSettingsPageRole(user?: User): boolean {
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions != null && permissions.some(m => m.startsWith('systemSettings.'));
}

export function isSuperadmin(user?: User): boolean {
  if (!user || !user.roles) {
    return false;
  }
  return user.roles.some(m => m.name === 'Superadmin');
}

export function hasPermission(user: User | undefined, permission: string): boolean {
  // return false;
  if (!user) return false;
  if (isSuperadmin(user)) return true;
  const permissions = getPermissions(user);
  return permissions?.some(p => p === permission) || false;
}

function getPermissions(user?: User): string[] | null {
  if (!user || !user.permissions) {
    return null;
  }
  return user.permissions.map(m => m.key);
}
